import { render, staticRenderFns } from "./SearchHistory.vue?vue&type=template&id=501d93e8&scoped=true"
import script from "./SearchHistory.vue?vue&type=script&lang=js"
export * from "./SearchHistory.vue?vue&type=script&lang=js"
import style0 from "./SearchHistory.vue?vue&type=style&index=0&id=501d93e8&prod&scoped=true&lang=css"
import style1 from "./SearchHistory.vue?vue&type=style&index=1&id=501d93e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501d93e8",
  null
  
)

export default component.exports